import { config } from "../constant";

function url(path: string): string {
  const trimmedPath = path.startsWith("/") ? path.slice(1) : path;
  return `${config().API_URL}/${trimmedPath}`;
}


function urlNew(path: string): string {
  const trimmedPath = path.startsWith("/") ? path.slice(1) : path;
    return `${config().API_URL}/${trimmedPath}`;
}
function tpiCBAPI(): string {
  return `${config().TPICB_URL}`};

const BASE_URL = url("");
const BASE_URLNEW = urlNew("");
const BASE_URLCBAPI = tpiCBAPI();
export const UrlConstants = {
  URL: function(url: any): string {
    return `${BASE_URL}${url}`;
  },
  URLNEW: function(url: any): string {
    return `${BASE_URLNEW}/${url}`;
  },
  tpiCBAPI:function(urla:any): string {
    return `${BASE_URLCBAPI}/${urla}`;
  }
};
